import styled from "styled-components"


export const DesignPage = () => {
  return (
    <StyleWrap>
      NamingConventions
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;